import React, { useState } from 'react'
import {BiSearchAlt} from 'react-icons/bi';
import {useGlobalContext} from '../../Utils/ContextApi';
import {useNavigate, useParams} from 'react-router-dom';
import {fetchData} from '../../Utils/FetchData'
import './form.css'

function TvForm() {
    const navigate = useNavigate()
    const {name} = useParams()

    const [tvSearch, setTvSearch] = useState('')
    const {tvResult, setTvResult} = useGlobalContext()
   
    
    const handler = async (e) => {
        e.preventDefault()
        if(tvSearch){
            const moviesData = await fetchData(`https://api.themoviedb.org/3/search/tv?api_key=${process.env.REACT_APP_API_KEY}&query=${tvSearch}`);

            const movies = moviesData.filter((movie)=>{
                return movie.name.toLowerCase().includes(tvSearch)
            })
            setTvResult(moviesData)
            setTvSearch('')
        }
        navigate('/searchtv')
    }
    
  return (
    <div className='form-container'>
    <form className='form' onSubmit={handler}>
        <input 
            type='text'
            placeholder='Search For Series'
            name={tvSearch}
            value={tvSearch}
            onChange={(e) => setTvSearch(e.target.value)}
            style={{textTransform:'lowercase'}}
        />
        <button style={{cursor:'pointer'}}><BiSearchAlt /></button>
    </form>
</div>
  )
}

export default TvForm